var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgBin16X16 = function SvgBin16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2a1 1 0 00-1 1v2H4a1 1 0 000 2h1v14a1 1 0 001 1h12a1 1 0 001-1V7h1a1 1 0 100-2h-3V3a1 1 0 00-1-1H8zM7 20V7h10v13H7zM9 9h2v9H9V9zm6 0h-2v9h2V9z",
    fill: "#9CA6AD"
  })));
};

export default SvgBin16X16;